/** Placeholder while the staff list and viewer profile load. */
export default function UsersLoadingState() {
  return (
    <div className="text-sm text-stone-500 dark:text-stone-400 py-12 text-center">
      Loading users…
    </div>
  );
}
